import { render, staticRenderFns } from "./StorageSpaceUpdate.vue?vue&type=template&id=469c673a&"
import script from "./StorageSpaceUpdate.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports